import { AgentSystemFinal } from './components/AgentSystemFinal';
import './styles/globals.css';

function App() {
  return <AgentSystemFinal />;
}

export default App;
